// import axios from 'axios'
import requests from '../utils/request'

// 关于我们
export const getAboutUsInfo = ()=>{
    return requests({
        url:'/buyer/platform/list',
        method:'get',
    }) 
}